
const EventEmitter = require('events');
const assert = require('assert');

const _ = require('lodash');
const Q = require('q');

import kv from 'rgs-knockout-validation';

const server = require('server');
const page = require('page-common');

const CalculatorFeedbackModel = require('./model').default;

const template = require('../templates/form.html');

import { OSAGO_FEEDBACK_CATEGORY } from 'known-feedback-categories';

module.exports = class CalculatorFeedbackFormController extends EventEmitter {
	constructor (options) {
		super();

		this._model = new CalculatorFeedbackModel({
			fileupload: this._fileuploadOptions(),
			dictionaries: options.dictionaries,
			profile: options.profile,
		});

		// prefill category even if user not authenticated
		// (used as `Category` option with `init` call)
		this._model.Category(options.Category || OSAGO_FEEDBACK_CATEGORY);

		this._model.on('sendButtonClick', this._sendButtonClick.bind(this));

		server.my.cmsapi.lk.updateUserProfileSummary()
			.then(({ responseJSON }) => {
				this.loadPrefilling(_.defaults({
					IsAuthenticated: Boolean(responseJSON.UserProfileID),
				}, responseJSON));
			})
			.catch(function (e) {
				console.warn(e);
			})
			.done();
	}

	loadPrefilling (data) {
		this._model.fromJS(data);
		// mark all valid prefilled observables as prefilled
		_.each(data, (v, k) => {
			const obs = this._model[k];
			if (!obs || !obs.isPrefilled) {
				return;
			}

			obs.isPrefilled(
				!kv.utils.isValidatable(obs)
					|| obs.isValid()
			);
		});
	}

	_sendButtonClick () {
		if (this._model.validationGroup().guard()) {
			return;
		}

		assert(this._fileuploadData, 'fileuploadData is required for submit');

		this._model.Busy(true);

		Q(this._fileuploadData.submit())
			.then((data) => {
				if (data.Status === 'SubmittingTooOften') {
					page.notifications.push({
						css: { 'notification-danger': false },
						message:
							'Служба поддержки обрабатывает ваше предыдущее обращение '
							+ (data.Data.PreviousFeedbackID || '')
							+ ' с указанного email. Пожалуйста, ожидайте ответа специалиста',
					});
					
					return data;
				}
				if (data.Status !== 'Success') {
					throw new Error(data.Status);
				}
				return data;
			})
			.then((data) => {
				this._model.FeedbackID(data.Data.FeedbackID);
				if (!data.Data.PreviousFeedbackID) {
					this._model.Submitted(true);
				}
			})
			.finally(() => {
				this._model.Busy(false);
			})
			.done();
	}

	_fileuploadOptions () {
		return {
			url: '/api/calculatorFeedback',
			autoUpload: false,
			forceIframeTransport: true,
			replaceFileInput: false,
			dataType: 'json',
			formAcceptCharset: 'utf-8',

			guaranteeAddHack: true,

			add: this._fileuploadAdd.bind(this),
			change: this._fileuploadChange.bind(this),
			submit: this._fileuploadSubmit.bind(this),
		};
	}

	_fileuploadChange (e, data) {
		this._model.Files(data.files);
	}

	_fileuploadAdd (e, data) {
		this._fileuploadData = data;
	}

	_fileuploadSubmit (e, data) {
		data.formData = this._model.toJS();

		const ctx = {};
		this.emit('enrichComplaintContext', ctx);
		_.extend(data.formData, ctx);

		_.each(data.formData, function (v, k) {
			if (!v && k !== 'PreviousPolicyIsRgs') {
				delete data.formData[k];
			}
		});
	}

	_resetStatus () {
		this._model.Submitted(false);
		this._model.ErrorCode(null);
	}

	_template () {
		return {
			html: template(),
			data: this._model,
		};
	}
};
